import { render } from "./AdminEmployeesPanel.vue?vue&type=template&id=54c8bed5&scoped=true"
import script from "./AdminEmployeesPanel.vue?vue&type=script&lang=js"
export * from "./AdminEmployeesPanel.vue?vue&type=script&lang=js"

import "./AdminEmployeesPanel.vue?vue&type=style&index=0&id=54c8bed5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c8bed5"]])

export default __exports__